import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { validationRule } from "../../utils/constant";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { checkValidation } from "../../utils/helper";
import { commonService } from "../../utils/commonService";

const AddRoomDistributionModal = ({
  showModal,
  closeModal,
  numberofroomsArray,
  handleDateWiseRoomChange,
  errorObj,
}) => {
  return (
    <>
      <Modal
        className="AddPropertySetupModalMain"
        size="lg"
        centered
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Room Distribution by Date
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xl={12}>
              <div className="ViewPropertySetupTable">
                <div className="stripped__table">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Stay Date's</th>
                        <th className="text-end pe-5">Rooms</th>
                      </tr>
                    </thead>
                    <tbody id="dayByDayBody">
                      {numberofroomsArray && numberofroomsArray.length > 0 ? (
                        numberofroomsArray.map((item) => (
                          <tr key={item.dateKey}>
                            <td>{commonService.getDateInFormat(item.date)}</td>
                            <td className="text-end" style={{ maxWidth: "180px" }}>
                              <input id={commonService.generateGlobalClickTrackerID("AddRoomDistributionModal", "rooms", item)}
                                className="form-input"
                                type="number"
                                min="0"
                                value={item.rooms}
                                onChange={(e) => handleDateWiseRoomChange(item.dateKey, e.target.value)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center">
                            No dates available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {errorObj?.numberofrooms && (
                    <small className="text-danger">
                      {errorObj?.numberofrooms}
                    </small>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button id={commonService.generateGlobalClickTrackerID("AddRoomDistributionModal", "close", "")} className="default-btn secondary-btn" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddRoomDistributionModal;
